import { componentName, TimerButtonClass } from './TimerButtonClass';
import '@descope-ui/descope-button';
import '@descope-ui/descope-timer';

customElements.define(componentName, TimerButtonClass);

export { TimerButtonClass, componentName };
